import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { CodeNode } from '@lexical/code';
import { TableNode } from '@lexical/table';
import { $stripLink, $flattenTable, $codeBlockToParagraph } from './docTransforms';

/** Keeps the editor's document inside what its toolbar can express: links are
 *  stripped to plain text, and pasted tables and code blocks are flattened to
 *  paragraphs. Node transforms run on every mutation, so paste, drop and
 *  programmatic inserts are all covered. */
export function DocHygienePlugin() {
  const [editor] = useLexicalComposerContext();
  useEffect(
    () =>
      mergeRegister(
        editor.registerNodeTransform(LinkNode, $stripLink),
        editor.registerNodeTransform(AutoLinkNode, $stripLink),
        editor.registerNodeTransform(TableNode, $flattenTable),
        editor.registerNodeTransform(CodeNode, $codeBlockToParagraph),
      ),
    [editor],
  );
  return null;
}
